<template>
  <div>
    <WtDataTable ref="tables"
                 :listUrl="$db.config.com_project.info.report_list"
                 :urlParams="{project_type:1,id:pid}">
      <template slot="columns">
        <el-table-column label="报告名称"
                         min-width="150"
                         align="center">
          <template slot-scope="scope">
            <a style="color:rgb(32, 153, 205);cursor: pointer;"
               @click="look(scope.row)">{{scope.row.report_name}}</a>
          </template>
        </el-table-column>

        <el-table-column label="资助总费用"
                         prop="total_medical_expenses"
                         align="center"
                         min-width="150">
          <template slot-scope="scope">{{scope.row.total_medical_expenses | setNumFormat}}</template>
        </el-table-column>

        <el-table-column label="筛查人数"
                         prop="report_screen_number"
                         align="center"
                         min-width="150"></el-table-column>

        <el-table-column label="救助人数"
                         prop="apply_count"
                         align="center"
                         width="100">
          <template slot-scope="scope">
            <a style="color:rgb(32, 153, 205);cursor: pointer;"
               href="javascript:;"
               @click="showApplyList(scope.row)">{{scope.row.apply_count}}</a>
            <!-- <span v-else>{{scope.row.apply_count}}</span> -->
          </template>
        </el-table-column>

        <el-table-column label="日期"
                         prop="addtime"
                         align="center"
                         min-width="150">
          <template slot-scope="scope">{{scope.row.regdate_start}} 至 {{scope.row.regdate_end}}</template>
        </el-table-column>

        <el-table-column label="操作"
                         min-width="100"
                         align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button type="primary"
                         icon="el-icon-edit"
                         size="mini"
                         @click="edit(scope.row)">编辑</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </template>
    </WtDataTable>

    <info v-if="if_open"
          v-model="if_open"
          :title="modal_title"
          :pid="pid"
          :id="report_id"
          :aid="approval_id"
          :disabled="disabled"
          @success="success"></info>

    <el-dialog :visible.sync="apply_list_show"
               :title="`${report_name} -- 救助列表`">
      <WtDataTable ref="tables2"
                   v-if="apply_list_show"
                   :listUrl="$db.config.com_project.apply.list"
                   :urlParams="{report_id:report_id,status_type:3}">
        <template slot="columns">
          <el-table-column label="姓名"
                           prop="aid_user_name"
                           min-width="80"
                           align="center">
            <template slot-scope="scope">
              <a href="JavaScript:;"
                 @click="applyLook(scope.row.id)">{{scope.row.aid_user_name}}</a>
            </template>
          </el-table-column>

          <el-table-column label="身份证"
                           prop="card_no"
                           align="center"
                           min-width="150"></el-table-column>

          <el-table-column label="眼疾"
                           prop="eye_disease_text"
                           align="center"
                           min-width="70"></el-table-column>

          <el-table-column label="项目名称"
                           prop="project_name"
                           min-width="100"
                           align="center"></el-table-column>

          <el-table-column label="项目阶段"
                           prop="report_name"
                           min-width="100"
                           align="center"></el-table-column>

          <el-table-column label="入院时间"
                           prop="access_time"
                           min-width="80"
                           align="center"></el-table-column>

          <el-table-column label="困难程度"
                           prop="poor_type_text"
                           min-width="100"
                           align="center"></el-table-column>

          <el-table-column label="状态"
                           prop="status_text"
                           min-width="100"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">
                <span v-if="scope.row.audit_result == 1">{{scope.row.audit_result_text}}</span>
                <span v-else>{{scope.row.status_text}}</span>
              </span>
              <span v-else>
                <span v-if="scope.row.audit_result == 2"
                      style="color:red;text-decoration: underline; cursor: pointer;">
                  <el-popover placement="top"
                              title="审核意见："
                              width="200"
                              trigger="click"
                              :content="scope.row.audit_opinion">
                    <span slot="reference">{{scope.row.audit_result_text}}</span>
                  </el-popover>
                </span>
                <span v-else>{{scope.row.status_text}}</span>
              </span>
            </template>
          </el-table-column>
        </template>
      </WtDataTable>
    </el-dialog>

    <apply-detail :id="apply_id"
                  v-model="if_open1"
                  v-if="if_open1"
                  :ifdisabled="true"></apply-detail>
  </div>
</template>

<script>
import applyDetail from "../apply/info";
import info from "./report";
export default {
  components: {
    info,
    applyDetail
  },
  props: {
    pid: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      if_open: false,

      if_open1: false, //查看救助申请人详情
      apply_id: null, //救助人id

      report_id: null,
      approval_id: null,
      modal_title: null,
      disabled: false,
      apply_list_show: false, //救助列表
      report_name: null //报告名称
    };
  },

  methods: {
    // 查看报告
    look (row) {
      this.report_id = row.id;
      this.approval_id = row.approval_id;
      this.modal_title = row.project_name;
      this.disabled = true;
      this.if_open = true;
    },

    success () {
      this.$refs.tables.reloadData();
    },

    // 查看
    applyLook (id) {
      this.apply_id = id;
      this.if_open1 = true;
    },

    //查看报告救助人数
    showApplyList (row) {
      this.report_id = row.id;
      this.report_name = row.report_name;
      this.apply_list_show = true;
    },

    //编辑报告
    edit (row) {
      this.report_id = row.id;
      this.modal_title = row.project_name;
      this.approval_id = row.approval_id;
      this.disabled = false;
      this.if_open = true;
    }
  },
  mounted () { }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/info/report_info.vue